import { createSelector } from 'reselect'
import { createMuiTheme } from '@material-ui/core/styles'

const getThemeSelector = state => state.theme

export const createTheme = createSelector(getThemeSelector, theme =>
  createMuiTheme(theme)
)
